export const COLOR_WHITE = "#FFFFFF";
export const COLOR_BLACK = "#000000";

export const COLOR_GREY_1 = "#FCFCFC";
export const COLOR_GREY_2 = "#F9F9F9";
export const COLOR_GREY_3 = "#F1F1F1";
export const COLOR_GREY_4 = "#EBEBEB";
export const COLOR_GREY_5 = "#E4E4E4";
export const COLOR_GREY_6 = "#DDDDDD";
export const COLOR_GREY_7 = "#D4D4D4";
export const COLOR_GREY_8 = "#BBBBBB";
export const COLOR_GREY_9 = "#8D8D8D";
export const COLOR_GREY_10 = "#808080";
export const COLOR_GREY_11 = "#646464";
export const COLOR_GREY_12 = "#202020";
export const COLOR_GREY_13 = "#717680";

export const COLOR_GREY50 = "#F5F5F5";
export const COLOR_GREY100 = "#CAC8C8";
export const COLOR_GREY200 = "#9A9A9A";
export const COLOR_GREY300 = "#747474";
export const COLOR_GREY400 = "#5C5C5C";
export const COLOR_GREY500 = "#424242";
export const COLOR_GREY600 = "#333333";
export const COLOR_GREY700 = "#1D1D1D";
export const COLOR_GREY800 = "#030303";
export const COLOR_GREY900 = "#101828";

export const COLOR_PRIMARY_MAIN = "#3C82FD";
export const COLOR_PRIMARY_DARK = "#004171";
export const COLOR_PRIMARY_LIGHT = "#01C5FF";
export const COLOR_PRIMARY_BACKGROUND = "#EBF3FF";

export const COLOR_SECONDARY_MAIN = "#EF3C2B";
export const COLOR_SECONDARY_DARK = "#8E0E08";
export const COLOR_SECONDARY_LIGHT = "#FF7555";
export const COLOR_SECONDARY_ORANGE = "#FF7B00";

export const COLOR_SPRING_GREEN_LIGHT = "#A7FCD2";

export const COLOR_ERROR = "#EF3C2B";
export const COLOR_GREEN = "#A2FFAC";
export const COLOR_LIGHT_GREEN = "rgb(236, 253, 243)";
export const COLOR_DARK_GREEN = "rgb(6, 118, 71)";
export const COLOR_RED = "#FFA2A2";
export const COLOR_LIGHT_RED = "rgb(254, 243, 242)";
export const COLOR_DARK_RED = "rgb(240, 68, 56)";
export const COLOR_YELLOW = "#FFDCA2";
export const COLOR_BLUE = "#A2F4FF";
export const COLOR_PINK = "#FADDFF";
export const COLOR_PURPLE = "#EADDFF";
export const COLOR_ORANGE = "#FFC668";
export const COLOR_DARK_BLUE = "#CED3FF";

export const COLOR_MENU = "#001a2d";

export const COLOR_ALERT_TITLE = "#2F3133";

export const COLOR_WHITE_TRANSPARENT = (opacity = 0.8) =>
  `rgba(255, 255, 255, ${opacity})`;
export const COLOR_BLACK_TRANSPARENT = (opacity = 0.8) =>
  `rgba(0, 0, 0, ${opacity})`;

export const COLOR_BLACK_5 = COLOR_BLACK_TRANSPARENT(0.05);
export const COLOR_BLACK_10 = COLOR_BLACK_TRANSPARENT(0.1);
export const COLOR_BLACK_20 = COLOR_BLACK_TRANSPARENT(0.2);
export const COLOR_BLACK_40 = COLOR_BLACK_TRANSPARENT(0.4);
export const COLOR_BLACK_60 = COLOR_BLACK_TRANSPARENT(0.6);
export const COLOR_BLACK_70 = COLOR_BLACK_TRANSPARENT(0.7);
export const COLOR_BLACK_80 = COLOR_BLACK_TRANSPARENT(0.8);

export const COLOR_WHITE_5 = COLOR_WHITE_TRANSPARENT(0.05);
export const COLOR_WHITE_10 = COLOR_WHITE_TRANSPARENT(0.1);
export const COLOR_WHITE_20 = COLOR_WHITE_TRANSPARENT(0.2);
export const COLOR_WHITE_40 = COLOR_WHITE_TRANSPARENT(0.4);
export const COLOR_WHITE_60 = COLOR_WHITE_TRANSPARENT(0.6);
export const COLOR_WHITE_80 = COLOR_WHITE_TRANSPARENT(0.8);

export const COLOR_CORAL = "#D46B6A";
export const COLOR_LIGHT_BLUE = "#5090FD";

// Elevation
export const ELEVATION_POPUP =
  "0px 2px 2px rgba(0, 0, 0, 0.1), 0px 0px 1px rgba(0, 0, 0, 0.15), 0px 8px 16px rgba(0, 0, 0, 0.15)";

export const COLOR_BORDER = COLOR_GREY_5;

export const BORDER = (width = 1, color = COLOR_BORDER) => {
  return `${width}px solid ${color}`;
};
